import * as React from 'react';
import Helmet from 'react-helmet';
import {Link, RouteComponentProps, withRouter, Route} from 'react-router-dom';
import Breadcrumb, {BreadcrumbItem} from '../../../components/Breadcrumb';
import Card, {CardBody, CardHeader} from '../../../components/Card';
import AirbnbLogin from './AirbnbLogin';
import AirbnbCredentialsVerification from './AirbnbCredentialsVerification';
import SelectAirbnbListings from './SelectAirbnbListings';
import AirbnbLoginSuccess from './AirbnbLoginSuccess';

class ConnectAirbnb extends React.Component<RouteComponentProps, {}> {
  public render() {
    const {match} = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>Connect your listings from Airbnb</title>
        </Helmet>

        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">Dashboard</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>Connect your listings from Airbnb</BreadcrumbItem>
        </Breadcrumb>
        <Card style={{marginTop: 20}}>
          <CardHeader>Connect your listings from Airbnb</CardHeader>
          <CardBody>
            <Route path={`${match.path}/success`} component={AirbnbLoginSuccess} />
            <Route path={`${match.path}/choose_listings`} component={SelectAirbnbListings} />
            <Route path={`${match.path}/verification`} component={AirbnbCredentialsVerification} />
            <Route exact={true} path={match.path} component={AirbnbLogin} />
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

export default withRouter(ConnectAirbnb);



// WEBPACK FOOTER //
// ./src/pages/ConnectListings/ConnectAirbnb/ConnectAirbnb.tsx